












































import Vue from 'vue'
import { BeneficiaryGroupService } from '@/api/services/beneficiary-groups'

export default Vue.extend({
  data() {
    return {
      loading: false,
      groups: [] as any[],
      columns: [
        {
          label: 'Nom du groupe',
          field: 'name',
          searchable: true
        },
        {
          label: 'Montant Perçu',
          field: 'totalReceived'
        },
        {
          label: 'Montant Escompté',
          field: 'totalDue'
        },
        {
          label: 'Statut',
          field: 'status'
        },
        {
          label: 'Actions',
          field: '_actions',
          align: 'left'
        }
      ]
    }
  },

  computed: {
    dispatchingId(): string {
      return this.$route.params.dispatchingId
    }
  },

  async created(this: any) {
    this.loading = true
    try {
      this.groups = await BeneficiaryGroupService.findForRefunds(
        this.dispatchingId
      )
    } catch (error) {
      console.error(error)
    } finally {
      this.loading = false
    }
  },

  methods: {
    onSeeDetails(group: { id: string }) {
      // TODO: Disbursments Details page
      this.$router.push({
        name: 'finances.refunds.details',
        params: { beneficiaryGroupId: group.id }
      })
    }
  }
})
